import { Activity, Database, Layers, type LucideIcon, Search, Split } from 'lucide-react';

import type { EventTone } from './AgentEventItem.types';

/**
 * Visual mapping per `agent_events.event_type`. Unknown types fall back to
 * `DEFAULT_EVENT_STYLE` so new backend events render without a frontend
 * change (the row still shows summary + payload).
 */
export const EVENT_TYPE_STYLES: Record<string, { icon: LucideIcon; tone: EventTone }> = {
	rag_classification: { icon: Split, tone: 'info' },
	kb_domain_search: { icon: Search, tone: 'neutral' },
	rag_supervisor_search: { icon: Layers, tone: 'neutral' },
	kb_search: { icon: Database, tone: 'primary' },
};

export const DEFAULT_EVENT_STYLE: { icon: LucideIcon; tone: EventTone } = { icon: Activity, tone: 'neutral' };

export const TONE_CLASS: Record<EventTone, string> = {
	info: 'bg-blue-50 text-info',
	neutral: 'bg-grey-25 text-subtle',
	warning: 'bg-yellow-50 text-warning',
	primary: 'bg-purple-50 text-purple-700',
};

/** A domain search that fell back to the unscoped path is worth flagging. */
export const FALLBACK_MATCH_STEP = 'flat-country';

/**
 * Indent per nesting level, in pixels. It works together with the vertical
 * guide: on its own the offset just reads as "shifted", not as "hangs off".
 */
export const NESTED_INDENT_PX = 24;
